module.exports = __webpack_public_path__ + "static/media/notification.c963fb87.jpg";